import { Button, Grid, PageHeader, useWindowDimensions } from '@cxc/react-fpds-components';
import { CaretLeft, CaretRight } from '@cxc/react-fpds-icons-v1';
import { useNavigate } from 'react-router-dom';
import { FPG_PAGE_ROUTE } from '../../constants/Routes';
import { isTablet } from '../../utils';
import { NavigationBarProps } from '../../types/props/NavigationBarProps';

const NavigationBar = ({ title, showNextPrevButtons = true }: NavigationBarProps) => {
    const navigate = useNavigate();
    const { width } = useWindowDimensions();
    const itemStyles = {
        paddingTop: '24px',
    };

    const buttonContainerStyles = {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '16px',
    };

    const handleBackNavigation = () => {
        navigate(FPG_PAGE_ROUTE);
    };

    return (
        <Grid style={itemStyles}>
            <Grid.Item style={{ alignItems: 'center', display: 'flex' }} xl={8} l={8} m={12} s={12}>
                <PageHeader
                    style={{ paddingTop: '0px' }}
                    titleProp={{ title }}
                    hideBackground
                    bottomStroke={false}
                />
            </Grid.Item>

            <Grid.Item
                style={
                    isTablet(width)
                        ? { order: '2', ...buttonContainerStyles }
                        : { ...buttonContainerStyles }
                }
                xl={4}
                l={4}
                m={6}
                s={6}
            >
                {showNextPrevButtons && (
                    <>
                        <Button
                            onClick={() => {
                                alert('Previous button was triggered');
                            }}
                            size="medium"
                            buttonColor="default"
                            buttonType="secondary"
                            leftIcon={<CaretLeft />}
                            as="button"
                        >
                            Previous
                        </Button>
                        <Button
                            onClick={() => {
                                alert('Next button was triggered');
                            }}
                            size="medium"
                            buttonColor="default"
                            buttonType="secondary"
                            rightIcon={<CaretRight />}
                            as="button"
                        >
                            Next
                        </Button>
                    </>
                )}
            </Grid.Item>
            <Grid.Item style={isTablet(width) ? { order: '1' } : {}} m={6} s={6}>
                <Button
                    onClick={handleBackNavigation}
                    size="medium"
                    buttonColor="default"
                    buttonType="text"
                    leftIcon={<CaretLeft />}
                    as="button"
                >
                    Back
                </Button>
            </Grid.Item>
        </Grid>
    );
};

export default NavigationBar;
